import "./Admin.css";
import DeleteModal from "../../components/Modals/DeleteConfirmation";
import CreatePartner from "../../components/Modals/CreatePartner";
import Details from "../../components/Modals/UserDetails";
import Table from "../../components/Table/Table";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../actions/user.actions";
import SearchBar from "../../components/forms/Searchbar";
import { sortData } from "../../utils/utils";
import { userService } from "../../services/user.service";
import DeleteUserModal from "../../components/Modals/DeleteModal";

export default function Admin() {
  const users = useSelector((state) => state.users.items);
  const dispatch = useDispatch();
  const userUpdated = useSelector((state) => state.admin.updated_user);
  const userDeleted = useSelector((state) => state.admin.removed_user);

  const [data, setData] = useState();
  const [searchValue, setSearchValue] = useState();
  const [userId, setUserId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [userDetail, setUserDetail] = useState();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (users) {
      setData(users.data);
    }
  }, [users]);

  useEffect(() => {
    if (userUpdated) {
      dispatch(userActions.getAll());
    }
  }, [dispatch, userUpdated]);

  useEffect(() => {
    if (userDeleted) {
      dispatch(userActions.getAll());
    }
  }, [dispatch, userDeleted]);

  useEffect(() => {
    dispatch(userActions.getAll());
  }, [dispatch]);

  const columns = [
    {
      name: "Company Name",
      code: "companyName",
    },
    {
      name: "Last Name",
      code: "lastName",
    },
    {
      name: "First Name",
      code: "firstName",
    },
    {
      name: "Email",
      code: "email",
    },
    {
      name: "PhoneNumber",
      code: "phoneNumber",
    },
    {
      name: "User Role",
      code: "userRole",
    },
    {
      name: "Actions",
    },
  ];

  const onSearch = (e) => {
    setSearchValue(e);
  };

  const handleChangeDelete = (changes) => {
    setShowModal(false);
  };

  useEffect(() => {
    if (searchValue) {
      const dataFiltered = users?.data.filter(
        (cert) =>
          cert.firstName?.toLowerCase().includes(searchValue) ||
          cert.lastName?.toLowerCase().includes(searchValue) ||
          cert.email?.toLowerCase().includes(searchValue) ||
          cert.userRole?.toLowerCase().includes(searchValue)
      );
      setData(dataFiltered);
    } else {
      setData(sortData(users?.data, "userRole"));
    }
  }, [searchValue, users]);

  const handleClickDetail = (userId) => {
    userService
      .getById(userId)
      .then((response) => setUserDetail(response.data));

    setUserId(userId);
  };

  const handleClickDelete = (userId) => {
    setShowModal(true);
    setDeleteId(userId);
  };

  return (
    <div className="flex flex-col px-12 admin-users">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Admin user dashboard</h1>
        <button
          type="button"
          data-hs-overlay="#hs-user-partner"
          className="py-3 px-9 bg-coc-green flex text-white text-xs items-center justify-center rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5 text-white mr-2"
          >
            <path
              fillRule="evenodd"
              d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
              clipRule="evenodd"
            />
          </svg>
          Create new partner
        </button>
      </div>

      <hr className="border-b-light-grey w-full h-2 my-4" />

      <SearchBar onSearch={onSearch} isPageAdmin={true} />
      <Table columns={columns} setCertificationList={setData}>
        {data &&
          data.map((dataa) => {
            return (
              <tr>
                <td></td>
                <td className="text-left">{dataa.companyName}</td>
                <td className="text-left">{dataa.lastName}</td>
                <td className="text-left">{dataa.firstName}</td>
                <td className="text-left">{dataa.email}</td>
                <td className="text-left">{dataa.phoneNumber}</td>
                <td className="text-left">{dataa.userRole}</td>
                <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium flex">
                  <button
                    type="button"
                    className="text-coc-blue hover:text-blue-800"
                    onClick={() => handleClickDelete(dataa.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6 text-red-600"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    data-hs-overlay="#hs-user-details"
                    className="text-coc-blue hover:text-blue-800 ml-4"
                    onClick={() => handleClickDetail(dataa.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                      <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
                    </svg>
                  </button>
                </td>
              </tr>
            );
          })}
      </Table>
      <DeleteUserModal
        userId={deleteId}
        showConfirmationModal={showModal}
        handleChange={handleChangeDelete}
      />
      <Details user={userDetail} userId={userId} />
      <CreatePartner />
    </div>
  );
}
